<template>
  <div class="wrapper">
    <h1 class="t">请在网页端打开</h1>
    <div class="desc">https://plat.zai-art.com <span @click="copy">复制链接</span></div>
    <div class="desc">来使用此功能</div>
  </div>
</template>
<script>
export default {
  name: '',
  metaInfo: { title: '404' },
  methods: {
    copy() {
      this.$copyText('https://plat.zai-art.com').then(
        e => {
          this.$toast.success('复制成功');
        },
        e => {
          this.$toast.fail('复制失败');
        },
      );
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  padding-top: 200px;
  min-height: 100vh;
  background: #fff;
}
h1 {
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
  margin-bottom: 13px;
}
.desc {
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  span {
    color: #3276fc;
  }
}
</style>
